import { Input } from "antd";

const SearchSelect = ({ searchQuery, setSearchQuery }) => {
  const onSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <Input
      width={"100%"}
      data-cy={"search"}
      placeholder="Search Tasks"
      onChange={onSearch}
      value={searchQuery}
      allowClear
    />
  );
};

export default SearchSelect;
